// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".is_boutique_E7OJI{--cp-primary_main:var(--cp-tertiary_special-main)}.brandSeoTitle_4TIhV{color:var(--cp-black);font-size:24px;font-weight:600;line-height:30px;margin-bottom:16px}.brandSeoText_hDkJk{font-size:14px;line-height:20px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"is_boutique": "is_boutique_E7OJI",
	"brandSeoTitle": "brandSeoTitle_4TIhV",
	"brandSeoText": "brandSeoText_hDkJk"
};
module.exports = ___CSS_LOADER_EXPORT___;
